import React from 'react';
import PropTypes from 'prop-types';

import FormattedLink from '@stubhub/react-formatted-link';
import {connect} from '@stubhub/react-store-provider';

import controller from './sub-category-controller';

import '../styles/nav-sub-category.scss';

export class NavSubCategoryList extends React.Component {
  static contextTypes = {
    globalRegistry: PropTypes.object,
  };

  constructor(props) {
    super(props);
    const {active, activeItem, menu, id, depth, onOptionClick, subMenus} = props;

    if (subMenus && menu?.length) {
      this.state = {active, activeItem};
      this.primaryCategoryOptions = this.generateDropdownOptions(menu, id, 0, activeItem, depth, onOptionClick);
    } else {
      this.state = {};
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {active: currentActive, activeItem: currentActiveItem, menu, id, depth, onOptionClick, subMenus} = this.props;
    const {active: newActive, activeItem: newActiveItem} = nextProps;
    if (subMenus && (currentActive !== !!newActive || currentActiveItem !== newActiveItem)) {
      this.setState({
        active: !!newActive,
        activeItem: newActiveItem,
      });
      if (currentActiveItem !== newActiveItem) {
        this.primaryCategoryOptions = this.generateDropdownOptions(
          menu,
          id,
          0,
          nextProps.activeItem,
          depth,
          onOptionClick
        );
      }
    }
  }

  findActiveIndex(mouseEvent) {
    if (mouseEvent) {
      let target = mouseEvent.target || {};
      const id = target.dataset && target.dataset.id;
      target = id && id.length ? target : (target.childNodes && target.childNodes.length && target.childNodes[0]) || {};

      return {id: target.dataset && target.dataset.id, value: target.innerText};
    }

    return {};
  }

  onMouseOver = (mouseEvent) => {
    const {onMenuHover, menu, depth} = this.props;

    if (mouseEvent) {
      const activeIndex = this.findActiveIndex(mouseEvent);
      const activeItem = activeIndex.id;
      const item =
        menu &&
        menu.find((e) => {
          return e.id === activeItem;
        });
      activeItem &&
        item &&
        (item.subMenu || depth === 0) &&
        typeof onMenuHover === 'function' &&
        onMenuHover(activeItem, null);
    }
  };

  // Returns an array of divs that represent each sub cat option
  generateDropdownOptions(data, id, columnIndex, activeItem, depth = 0, onOptionClick) {
    const {subMenus, debug} = this.props;
    let selectedTopNav = [];
    if (Array.isArray(data)) {
      if (subMenus) {
        if (id) {
          const menuData = data.find((e) => e.id === id);
          selectedTopNav = menuData ? menuData.subMenu : data;
        } else {
          selectedTopNav = data;
        }
      } else {
        selectedTopNav = data;
      }
    } else if (data && id) {
      selectedTopNav = data[id] || [];
    }
    const categoryNavOptions = selectedTopNav.map((item, index) => {
      if (subMenus) {
        const {id: itemId, name, webURI, subMenu} = item;
        const active = activeItem === itemId;
        const subMenuSection = subMenu && subMenu.length > 0 && (
          <NavSubCategoryList
            id={itemId}
            menu={subMenu}
            active={active}
            activeItem={activeItem}
            depth={depth + 1}
            onOptionClick={onOptionClick}
            subMenus={subMenus}
            debug={debug}
          />
        );
        const activeOption = !depth && active;
        const iconClassName = `sh-iconset sh-iconset-chevron${activeOption ? ' sh-iconset-chevron--active' : ''}`;
        const subMenuIcon = subMenu && subMenu.length > 0 ? <span className={iconClassName} /> : null;
        const optClassName = `subCat--option-link${activeOption ? ' subCat--option-link--active' : ''}`;

        return (
          <FormattedLink key={`subcat-option-link-${itemId}`} href={webURI}>
            <div className="subCat--option" key={`subcat-option-${itemId}-${index}`} onMouseOver={this.onMouseOver}>
              <span className="subCat--option-link-container">
                <span
                  className={optClassName}
                  data-index={index}
                  data-id={itemId}
                  data-columnindex={columnIndex}
                  onClick={onOptionClick}
                >
                  {name}
                </span>
                {subMenuIcon}
              </span>
              {subMenuSection}
            </div>
          </FormattedLink>
        );
      }
      const {name, webURI} = item;
      const campaignLink = webURI && webURI.indexOf('/campaign/') !== -1;

      return (
        <div className="subCat--option" key={`subcat-option-${id}-${index}`}>
          <FormattedLink
            className="subCat--option-link"
            href={webURI}
            data-index={index}
            data-id={id}
            data-columnindex={columnIndex}
            onClick={onOptionClick}
            externalLink={campaignLink}
          >
            {name}
          </FormattedLink>
        </div>
      );
    });

    return categoryNavOptions;
  }

  // Returns a column of sub category options
  createSubCatColumn(columnItems, uniqueClassName, categoryId, showHeading = false) {
    const className = `mh__nav-subCat-col ${uniqueClassName}`;
    // @TODO: Headings need to be localized
    const geoHeadingMsg = categoryId === 'sports' ? 'Local teams' : 'Popular near you';
    const geoHeading = showHeading ? <div className="subCat--heading">{geoHeadingMsg}</div> : null;

    return (
      <div className={className}>
        {geoHeading}
        {columnItems}
      </div>
    );
  }

  handleDocumentClick = (e) => {
    if (this.rootNode?.parentNode && !this.rootNode.parentNode.contains(e.target)) {
      const {onClickOutside} = this.props;
      onClickOutside && onClickOutside.call(this);
    }
  };

  componentDidMount() {
    /*
     * We only need to attach listener for the topmost instance
     * Cannot mock missing document
     */
    if (typeof document !== 'undefined') {
      document.addEventListener('click', this.handleDocumentClick);
      document.addEventListener('mouseout', this.handleDocumentClick);
    }
  }

  componentWillUnmount() {
    const {resetSubCatDropdown} = this.props;
    if (typeof document !== 'undefined') {
      document.removeEventListener('click', this.handleDocumentClick);
      document.removeEventListener('mouseout', this.handleDocumentClick);
    }
    resetSubCatDropdown && resetSubCatDropdown();
  }

  getStyle = () => {
    const {depth, menu, subMenus} = this.props;
    const {activeItem} = this.state;
    let style = {};

    if (subMenus && !depth && activeItem && activeItem.length) {
      const subMenu =
        menu &&
        menu.find((e) => {
          return e.id === activeItem;
        });
      if (subMenu && subMenu.subMenu && subMenu.subMenu.length) {
        const len = menu.length >= subMenu.subMenu.length ? menu.length : subMenu.subMenu.length + 1;
        const BASE_HEIGHT = 36;
        style = {
          width: '340px',
          height: `${BASE_HEIGHT * len}px`,
          transition: 'all 0.5s ease-in-out',
        };
      }
    }

    return style;
  };

  render() {
    const {onOptionClick, id, depth = 0, merchConfig, menu, subMenus, debug} = this.props;
    let {active} = this.state;
    active = debug ? true : active; // OJO DEB
    let firstColumn;

    if ((subMenus && menu?.length) || merchConfig) {
      const primaryCategoryOptions = subMenus
        ? this.primaryCategoryOptions
        : this.generateDropdownOptions(merchConfig, id, 0, '', depth, onOptionClick);
      firstColumn = this.createSubCatColumn(primaryCategoryOptions, 'first-col');

      const style = this.getStyle();
      const subCatClassName = subMenus
        ? `mh__nav-sub-category--subMenus mh__nav-sub-category mh__nav-sub-category--${
            active ? 'active' : 'inactive'
          } ${style.width ? 'mh__nav-sub-category--expandedMenu ' : ''}mh__nav-menu-depth-${depth}`
        : 'mh__nav-sub-category--noSubMenus mh__nav-sub-category';
      const subCatNavContent = (
        <div className={subCatClassName} style={style}>
          {firstColumn}
        </div>
      );

      return <div ref={(node) => (this.rootNode = node)}>{subCatNavContent}</div>;
    }

    return <div ref={(node) => (this.rootNode = node)} />;
  }
}

NavSubCategoryList.propTypes = {
  /** Unique identifier for the sub category */
  id: PropTypes.string.isRequired,

  /** Function to reset the sub category dropdown */
  resetSubCatDropdown: PropTypes.func.isRequired,

  /** Flag to indicate if the sub category is active */
  active: PropTypes.bool,

  /** Active item in the sub category */
  activeItem: PropTypes.string,

  /** Depth of the sub category */
  depth: PropTypes.number,

  /** Function to call when an option is clicked */
  onOptionClick: PropTypes.func,

  /** Function to call when clicked outside of the list */
  onClickOutside: PropTypes.func,

  /** Function to call when a menu item is hovered */
  onMenuHover: PropTypes.func,

  /** Flag to indicate if there are sub menus */
  subMenus: PropTypes.bool,

  /** Array of merch config */
  merchConfig: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),

  /** Array of menu items */
  menu: PropTypes.array,

  /** Flag to indicate if debug mode is on */
  debug: PropTypes.bool,
};

export default connect(controller)(NavSubCategoryList);
